import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Shield } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import eridonLogo from "@/assets/eridon-logo.png";

export function StickyScrollCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 500);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center py-2 px-4 glass-nav"
        >
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-2">
              <img src={eridonLogo} alt="ERIDON логотип" className="h-7 w-7 shrink-0" width={28} height={28} />
              <span className="text-sm font-bold text-foreground">ERIDON</span>
            </div>
            <Button size="sm" asChild className="gap-1.5 min-h-[48px] px-6 rounded-xl text-sm font-semibold glow-cta">
              <Link to="/#hero-scanner">
                <Shield className="h-4 w-4" />
                Проверить рекламу через AI
              </Link>
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
